import { useEffect } from "react";
import "./ExcluirModal.css";

export default function ExcluirModal({ open, titulo, onClose, onConfirmar }) {
  useEffect(() => {
    if (!open) return;

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    // Mantem ESC bloqueado neste popup
    const onKey = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    document.addEventListener("keydown", onKey, true);

    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener("keydown", onKey, true);
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="exmd-bg" data-exmd>
      <div className="exmd-box" role="dialog" aria-modal="true" aria-label="Excluir registro">
        <header className="exmd-head">
          <h3 className="exmd-title">Excluir</h3>
          <button className="exmd-x" onClick={onClose} type="button" aria-label="Fechar">
            x
          </button>
        </header>

        <div className="exmd-body">
          Tem certeza que deseja <strong>excluir</strong> "{titulo || "este registro"}"?
        </div>

        <footer className="exmd-foot">
          {/* Mantido: Cancelar nao fecha */}
          <button className="exmd-btn" type="button">Cancelar</button>
          <button className="exmd-btn exmd-btn-danger" onClick={onConfirmar} type="button">Excluir</button>
        </footer>
      </div>
    </div>
  );
}
